'use client';

import { useEffect, useState } from 'react';
import {
  getIfpCampaignParams,
  type IfpCampaignParams,
} from '@/lib/utm-tracker';

/**
 * Hook que retorna os parâmetros de campanha do cookie ifp_campaign_params.
 * Usa useState + useEffect para evitar hydration mismatch (mesmo padrão do useFirstTouchUTM).
 */
export function useIfpCampaignParams(): IfpCampaignParams | null {
  const [params, setParams] = useState<IfpCampaignParams | null>(null);

  useEffect(() => {
    const data = getIfpCampaignParams();
    // eslint-disable-next-line react-hooks/set-state-in-effect -- cookie read on mount, same pattern as useFirstTouchUTM
    setParams(data);
  }, []);

  return params;
}
